<button type="button" [attr.aria-label]="label" title="Button label"
    class="c11n-button c11n-button--small c11n-button--icon-ghost c11n--on-light " (click)="sortBy()">
    <span class="c11n-button__icon-only" *ngIf="initialColumn===sortColumn && arrowDirection==='caret-down-small'">
        <svg class="c11n-caret-down-small c11n-icon--smaller">
            <use xlink:href="#caret-down-small"></use>
        </svg>
    </span>
    <span class="c11n-button__icon-only" *ngIf="initialColumn===sortColumn && arrowDirection==='caret-up-small'">
        <svg class="c11n-caret-up-small c11n-icon--smaller">
            <use xlink:href="#caret-up-small"></use>
        </svg>
    </span>
    <span class="c11n-button__icon-only" *ngIf="initialColumn!==sortColumn">
        <svg class="c11n-caret-up-small c11n-icon--smaller">
            <use xlink:href="#caret-up-small"></use>
        </svg>
    </span>
</button>